define('apps/classrooms/views/modals/bulk_set_qr_generate',[
    'app',
    'i18next',
    'apps/classrooms/views/modals/bulk_set_qr_block_message',
    'apps/classrooms/views/modals/bulk_set_qr_distribute',
    'njs!apps/classrooms/templates/includes/components/modals/_bulk_set_qr_generate',
    'njs!apps/classrooms/templates/qr-code/includes/_feedback_messages',
    'common/components/comet/behaviors/take-over-modal-behavior',
    'apps/classrooms/views/pdf-utils/common',
], function(
    app,
    i18next,
    BulkSetQrMessage,
    BulkSetQrDistribute,
    template,
    feedBackMessage,
    TakeOverModalBehavior,
    pdfCommonUtils
) {
    'use strict';

    return Mn.ItemView.extend({
        "behaviors": {
            "TakeOverModalBehavior": {
                "behaviorClass": TakeOverModalBehavior
            }
        },

        "className": "bulk-qr",

        "events": {
            "click .bulk-qr-modal .js-comet-modal__button--takeover-close": "closeModal",
            "click .bulk-qr-modal .bulk-qr-generate": "generateQRCodes",
            "click .bulk-qr-modal .bulk-qr-continue-with-to-dashboard": "continueToDashboard",
        },

        "template": template,

        "currentRequest": null,

        /** Container to keep track of students whose qrs could not be generated */
        "studentsWithQRFailures": [],

        /** Container to keep track of students whose qrs are generated */
        "printStudents": [],

        "isLoading": false,

        "modelEvents": {
            "change:students": "render"
        },

        "onRender": function () {
            if (this.model.get('sureToExit')) {
                var message = i18next.t('If you exit now, you will lose all progress and have to re-issue the QR codes you have just generated.'),
                    $blockMessage = new BulkSetQrMessage({
                        "model": new Backbone.Model({
                            "message": message,
                            "sureToExit": true,
                            "nextUrl": this.model.get('nextUrl'),
                            "title": i18next.t('Warning!'),
                        })
                    });
                this.$('.bulk-qr-modal__container .block-message').append($blockMessage.render().$el);
                this.$('.bulk-qr-continue-to-download').removeClass('bulk-qr-form__elem--hidden');
                this.$('.bulk-qr-continue-with-code').addClass('bulk-qr-form__elem--hidden');
                return;
            }

            var teachers = this.model.get('teachers') || {};
            if (!teachers.no_teacher) {
                teachers.no_teacher = {
                    'details': {
                        'user_id': 'no_teacher',
                        'first_name': 'No',
                        'last_name': 'Teacher',
                    },
                    'students': [],
                };

                this.model.set('teachers', teachers);
            }

            this.$('.bulk-qr-modal__container .block-message').empty();
            var $blockMessage = new BulkSetQrMessage({
                "model": new Backbone.Model({
                    "allowClose": true,
                    "sureToContinue": true,
                    "message": feedBackMessage({"std_length": this.model.get('students').length, "message": "wish_to_continue"}),
                })
            });
            this.$('.bulk-qr-modal__container .block-message').append($blockMessage.render().$el);
        },

        /**
         * Close the modal
         */
        "closeModal": function (e) {
            this.destroy();
        },

        /**
         * When issuing QR Codes for an entire school, we could have N number of teacher/classroom
         *  owners associated with a given student. We have chunked out all teachers into small batches.
         *  We will go through each batch of teacher [ids] until we have exhausted the list and then
         *  allow the user to print or download all of the qr codes.
         */
        "fetchAssociatedOwners": function() {
            var teacherIdChunks = this.model.get('teacherIdChunks') || [];

            if (teacherIdChunks.length === 0) {
                this.model.set('needsAssociatedOwners', false);
                this.generateQRCodes();
                return;
            }

            var currentChunk = teacherIdChunks.shift();

            this.model.set('teacherIdChunks', teacherIdChunks);

            this.currentRequest = $.ajax({
                "url": '/apiproxy/v1/users/search-account-teachers',
                "type": 'POST',
                "headers": {
                    "X-Token": this.model.get('searchTeachersToken'),
                },
                "data": {
                    "teacher_ids": currentChunk,
                    "site_id": this.model.get('siteId') || (this.model.get('site') || {}).id,
                    "account_id": this.model.get('accountId') || (this.model.get('account') || {}).id,
                },
                "dataType": 'json',
                "xhrFields": {
                    "withCredentials": true
                },
                "beforeSend": _.bind(function() {
                    if (this.currentRequest !== null && this.currentRequest.readyState !== 4) {
                        this.currentRequest.abort();
                    };
                }, this),
                "success": _.bind(this.fetchAssociatedOwnersSuccess, this),
                "error": _.bind(function(response) {
                    // TODO: ask design about diplaying a message if fetching associated teachers fail.
                    //       for now, lets move our students into the No Teacher bucket so the user
                    //       will have an All Students bucket and No Teacher bucket.
                    this.model.set('needsAssociatedOwners', false);

                    var teachers = this.model.get('teachers') || {},
                        noTeacher = teachers.no_teacher,
                        failedTeacherIds = [];

                    $.each(Object.keys(this.model.attributes.teachers),
                        _.bind(function(_, teacherId) {
                            if (teacherId !== 'no_teacher') {
                                failedTeacherIds.push(teacherId);
                                noTeacher.students = noTeacher.students.concat(teachers[teacherId].students);
                            }
                        }, this)
                    );

                    // update model for pdf builder.
                    this.model.set('teachers', {
                        'no_teacher': noTeacher,
                        'failed_teachers': {
                            'students': [],
                            'teachers': failedTeacherIds,
                        }
                    });

                    // go back to our original code path for results and pdf generation.
                    this.generateQRCodes();
                }, this),
            });
        },

        "fetchAssociatedOwnersSuccess": function(response) {
            var teachers = this.model.get('teachers');

            this.model.set('account', response.account);
            this.model.set('site', response.site);

            // set teacher details on each teacher map property.
            $.each(response.teachers, _.bind(function (teacherId, teacher) {
                // if we do not have any teacher details or we are not able to
                //  view teacher details, lets move the students to no teacher bucket
                //  and empty students and details for that teacher.
                if (!teacher) {
                    teachers.no_teacher.students = teachers.no_teacher.students.concat(
                        teachers[teacherId].students
                    );

                    teachers[teacherId].students = [];
                    teachers[teacherId].details = {};

                    return;
                }

                teachers[teacher.user_id].details = teacher;
            }, this));

            // make sure we do not have any duplicates students after we have moved
            //  the students to a different bucket.
            teachers.no_teacher.students = _.uniq(teachers.no_teacher.students);

            this.model.set('teachers', teachers);

            this.fetchAssociatedOwners();
        },

        /**
         * Generate QR Codes
         */
        "generateQRCodes": function() {
            var students = this.model.get('students');

            if (!students.length) {
                var isAdmin = this.model.get('isAdmin'),
                    hasNoClassroom = !this.model.get('classroom'),
                    hasNoStudent = !this.model.get('student'),
                    teachers = this.model.get('teachers') || [],
                    teacherIdChunks = this.model.get('teacherIdChunks') || [];

                // only create teacher id chunks if they have not been set on the model.
                if (teacherIdChunks.length === 0 && this.model.get('needsTeacherIdChunks') !== false) {
                    var teacherIds = Object.keys(teachers).filter(function(id) {
                        return id !== 'no_teacher';
                    });

                    // update chunks to be used when fetching associated teachers for student bucketing.
                    teacherIdChunks = pdfCommonUtils.generateChunks(teacherIds, 50);

                    // set attr and mark as already chunked associated teacher ids.
                    this.model.set('teacherIdChunks', teacherIdChunks);
                    this.model.set('needsTeacherIdChunks', false);
                }

                if (isAdmin && hasNoClassroom && hasNoStudent) {
                    if (teacherIdChunks.length > 0) {
                        if (this.model.get('needsAssociatedOwners') !== false) {
                            this.model.set('needsAssociatedOwners', true);
                        }

                        this.fetchAssociatedOwners();
                    }
                }

                this.$('.bulk-qr-modal__container .block-message').empty(); // prepare block message container
                // if there is an error at the end, show some message about the error
                if (this.studentsWithQRFailures.length) {
                    var successStudentString = feedBackMessage({ "std_length": this.printStudents.length, "message": "success_student_string" }), // splitting to localize
                        successString = feedBackMessage({ "std_length": this.studentsWithQRFailures.length, "message": "success_string" }),
                        message = successStudentString + ' ' + successString,
                        title = i18next.t('Operation Complete!'),
                        $blockMessage = new BulkSetQrMessage({
                            "model": new Backbone.Model({
                                "isComplete": true,
                                "errors": this.studentsWithQRFailures.length > 0,
                                "message": message,
                                "title": title,
                            })
                        });

                    this.$('.bulk-qr-modal__container .block-message').append($blockMessage.render().$el);
                    this.$('.bulk-qr-modal__generate .bulk-qr-continue-with-to-dashboard').removeClass('bulk-qr-form__elem--hidden');

                } else {
                    var message = feedBackMessage({"std_length": this.printStudents.length, "message": "success"}),
                        title = i18next.t('Operation Complete!'),
                        $blockMessage = new BulkSetQrMessage({
                        "model": new Backbone.Model({
                            "isComplete": true,
                            "message": message,
                            "title": title,
                        })
                    });

                    this.$('.bulk-qr-modal__container .block-message').append($blockMessage.render().$el);
                    this.$('.bulk-qr-modal__generate .bulk-qr-continue-with-to-dashboard').removeClass('bulk-qr-form__elem--hidden');
               }
               return;
            }

            // show loading state while the user waits for qr-code generation to be completed
            if (!this.isLoading) { // run this once (skip it while in the loop)
                this.$('.bulk-qr-modal__container .block-message').empty();
                this.$('.bulk-qr-modal__generate .bulk-qr-continue-with-code').addClass('bulk-qr-form__elem--hidden');
                var $blockMessage = new BulkSetQrMessage({
                    "model": new Backbone.Model({
                        "isLoading": true,
                        "title": i18next.t('Please Wait... Generating QR Codes'),
                    })
                });
                this.$('.bulk-qr-modal__container .block-message').append($blockMessage.render().$el);

                this.isLoading = true;
            }

            /**
            *  The list of students here do not have qr
            *  codes will need to be issued for sign in.
            */
            this.model.set('students', students);

            this.model.set('currentStudent', students.shift());

            var generateToken = app.initData.get("tokens").qr_generate,
                postData = {
                    'user_guid': this.getCurrentStudent().user_id || this.getCurrentStudent().id,
                    'qr_badge_version': 2,
                };

            // if we dont need assistance, we need to add in the expiry
            if (this.model.get('currentStudent').qr_auth) {
                postData.replace_badge_issued_at = this.model.get('currentStudent').qr_auth.create_date_utc;
            }

            this.currentRequest = $.ajax({
                "url": '/apiproxy/v1/users/generate-qr-auth',
                "type": 'POST',
                "dataType": 'json',
                "headers": {
                    "X-Token": generateToken,
                },
                "data": postData,
                "xhrFields": {
                    "withCredentials": true
                },
                "beforeSend": _.bind(function() {
                    if (this.currentRequest !== null && this.currentRequest.readyState !== 4) {
                        this.currentRequest.abort();
                    };
                }, this),
                "success": _.bind(this.onGenerateSuccess, this),
                "error": _.bind(this.onGenerateError, this),
            });
        },

        "onGenerateSuccess": function(response) {
            var currentStudent = this.model.get('currentStudent');

            currentStudent.qrAuth = response.generated_qr_auth;
            currentStudent.qrAuth.localExpiryWithLabel = i18next.t('Expires') + ' ' +
                                                         currentStudent.qrAuth.localized_expires_date_utc;

            this.printStudents.push(currentStudent);

            var teachers = this.model.get('teachers'),
                associatedTeacherIds = response.teachers || [];

            if (teachers) {
                if (!response.teachers || response.teachers.length === 0) {
                    teachers.no_teacher.students.push(currentStudent);
                }

                $.each(associatedTeacherIds, _.bind(function (_, teacherId) {
                    if (!teachers[teacherId]) {
                        teachers[teacherId] = {};
                        teachers[teacherId].students = [];
                    }

                    teachers[teacherId].students.push(currentStudent);
                }, this));
            }

            this.generateQRCodes();
        },

        "onGenerateError": function (response) {
            var failedStudentId = this.getCurrentStudent();
            this.studentsWithQRFailures.push(failedStudentId);
            this.generateQRCodes();
        },

        /**
        * Return the current (target) students id
        *  Students that need qrs and Students api have different properties for guids,
        *  so we are going to use this convenience method to centralize grabbing the students id.
        */
        "getCurrentStudent": function () {
            return this.model.get('currentStudent') || {};
        },

        /**
         * Continue to Distribute Dashboard.
         */
        "continueToDashboard": function() {
            var printStudents = this.printStudents,
                studentsWithQRFailures = this.studentsWithQRFailures,
                teachers = this.model.get('teachers'),
                isAdmin = this.model.get('isAdmin'),
                isClassroom = this.model.get('classroom'),
                isStudent = this.model.get('student'),
                filename = '', downloadText;

            if (isAdmin && (!isClassroom && !isStudent)) {
                filename = this.model.get('site').name;
            } else if (isClassroom && !isStudent) {
                filename = this.model.get('classroom').name;
            } else {
                var student = this.model.get('student');
                filename = student.first_name + '_' + student.last_name;
            }

            downloadText = i18next.t('The .zip file %(filename)s.zip has been successfully downloaded to your computer, and contains all your newly issued student sign-in QR codes.', {
                'filename': filename,
            });

            var $distributeQrCodes = new BulkSetQrDistribute({
                "model": new Backbone.Model(
                    $.extend(this.model.attributes, {
                        'countryCode': initData.config.SERVER_COUNTRY_CODE || 'US',
                        'printStudents': printStudents,
                        'studentsWithQRFailures': studentsWithQRFailures,
                        'teachers': teachers,
                        'errors': (studentsWithQRFailures || []).length > 0,
                        'message': downloadText,
                    }))
                });

            var $parent = $('.qr-code__content');
            this.$('.bulk-qr-modal').remove();

            $parent.addClass('.qr-code__content distribute').empty();
            $parent.append($distributeQrCodes.render().$el);
        },
    });
});

